// This file is autogenerated from /frontend/sail-next/packages/docs/src/component-examples/ButtonGroup/NoOverflow.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Button, ButtonGroup} from '@sail/ui';
import {ResizableContainer} from '../common/ResizableContainer';
/* eslint-disable no-alert */

export const NoOverflow = () => {
  return (
    <ResizableContainer>
      <ButtonGroup collapse="none">
        <Button
          onPress={() => {
            console.log('Filter');
          }}
        >
          Filter
        </Button>
        <Button
          onPress={() => {
            console.log('Export');
          }}
        >
          Export
        </Button>
        <Button
          type="primary"
          onPress={() => {
            console.log('Save');
          }}
        >
          Save
        </Button>
      </ButtonGroup>
    </ResizableContainer>
  );
};
